import openPopupWindow from "./popup-window";
import { validateBrandWebsite, addProtocolToUrl } from "shared/helpers/urls";

$(document).on('turbo:load', function() {
  $(document).off('.aiCalendar');

  const form = $('#ai-calendar-setup-form');
  if (!form.length) return;

  const setupUrl = form.data('setup-url');
  const newCalendarPath = form.data('new-calendar-path');
  const csrfToken = $('meta[name="csrf-token"]').attr('content');
  const $nameInput = $('#ai-calendar-name');
  const $submitBtn = $('#ai-submit-btn');

  if (!$nameInput.length || !$submitBtn.length) return;

  let calendarId = form.data('calendar-id') || null;
  let channelSetUp = false;
  let pendingCreate = null;

  var $websiteInput = $('#website');

  function setFieldError($input, msg) {
    var $group = $input.closest('.form-group');
    $group.addClass('has-error');
    if (!$input.next('.help-block').length) {
      $input.after('<span class="help-block">' + msg + '</span>');
    }
  }

  function clearFieldError($input) {
    $input.closest('.form-group').removeClass('has-error');
    $input.next('.help-block').remove();
  }

  function isValidUrl(str) {
    if (!str) return true;
    try { var u = new URL(str); return u.protocol === 'http:' || u.protocol === 'https:'; }
    catch(e) { return false; }
  }

  function validateForm() {
    var valid = true;
    if (!$nameInput.val().trim()) {
      setFieldError($nameInput, 'Calendar name is required');
      $nameInput.focus();
      valid = false;
    }
    var raw = $websiteInput.val().trim();
    var websiteVal = raw ? addProtocolToUrl(raw) : '';
    if (websiteVal) {
      var websiteError = !isValidUrl(websiteVal)
        ? 'Please enter a valid URL (e.g. https://example.com)'
        : validateBrandWebsite(websiteVal);
      if (websiteError) {
        setFieldError($websiteInput, websiteError);
        if (valid) $websiteInput.focus();
        valid = false;
      }
    }
    return valid;
  }

  function updateSubmitState() {
    $submitBtn.prop('disabled', !$nameInput.val().trim());
  }
  $nameInput.on('input', function() {
    clearFieldError($nameInput);
    updateSubmitState();
  });
  $websiteInput.on('input', function() {
    clearFieldError($websiteInput);
  });

  function calendarUrl(id) {
    return newCalendarPath + '?calendar_id=' + id;
  }

  function setupBroadcastChannel(id) {
    if (channelSetUp) return;
    channelSetUp = true;

    $('<div data-inline-identity-connection-calendar-id="' + id + '"></div>')
      .appendTo('#ai-calendar-setup-form');

    window.onIdentityConnected = function(cId, identityId, reconnecting) {
      if (!identityId) return;
      window.location.href = calendarUrl(id);
    };

    window.onIdentityConnectionFailed = function(message) {
      alert(message || 'Connection failed. Please try again.');
    };

    const channel = new BroadcastChannel('loomly-inline-identity-connections--calendar-' + id);
    channel.onmessage = function(event) {
      if (!event.data || !event.data.type) return;
      if (event.data.type === 'identity-connection-failure') {
        window.onIdentityConnectionFailed(event.data.params.error);
      } else if (event.data.type === 'identity-connection-success') {
        const p = event.data.params;
        window.onIdentityConnected(p.calendarId, p.identityId, p.reconnecting);
      }
    };

    $(document).one('turbo:before-visit', function() {
      channel.close();
      delete window.onIdentityConnected;
      delete window.onIdentityConnectionFailed;
    });
  }

  function buildFormData() {
    var fd = new FormData();
    fd.append('authenticity_token', csrfToken);
    fd.append('calendar_name', $nameInput.val());
    var rawWebsite = $('#website').val().trim();
    fd.append('website', rawWebsite ? addProtocolToUrl(rawWebsite) : '');

    var $tz = $('#time_zone');
    if ($tz.length) fd.append('time_zone', $tz.val());

    var $wf = $('#workflow_type');
    if ($wf.length) fd.append('workflow_type', $wf.val());

    var $logoInput = $('#ai-advanced-settings-modal .js-logo-image-input-field');
    if ($logoInput.length && $logoInput[0].files[0]) fd.append('logo', $logoInput[0].files[0]);

    return fd;
  }

  function ensureCalendar() {
    if (calendarId) return $.Deferred().resolve(calendarId).promise();
    if (pendingCreate) return pendingCreate;

    $('.ai-connect-btn').prop('disabled', true);

    pendingCreate = $.ajax({
      url: setupUrl,
      type: 'POST',
      dataType: 'json',
      data: buildFormData(),
      processData: false,
      contentType: false
    }).then(function(data) {
      calendarId = data.id;
      form.find('input[name="calendar_id"]').val(calendarId);
      history.replaceState(null, '', calendarUrl(calendarId));
      setupBroadcastChannel(calendarId);
      if ($websiteInput.val().trim()) {
        $websiteInput.prop('disabled', true)
          .attr({ 'data-toggle': 'tooltip', 'data-placement': 'top',
            title: 'Your brand website cannot be modified at this stage. Please visit your calendar settings to modify it.' })
          .tooltip()
          .on('show.bs.tooltip', function() {
            if (window.trackPicoUserAction) window.trackPicoUserAction('ai_calendar_disabled_website_tooltip_shown', {});
          });
      }
      return calendarId;
    }).always(function() {
      pendingCreate = null;
      $('.ai-connect-btn').prop('disabled', false);
    });

    return pendingCreate;
  }

  $(document).on('click.aiCalendar', '.ai-connect-btn', function(e) {
    e.preventDefault();
    const btn = $(this);
    const provider = btn.data('provider');
    if (window.trackPicoUserAction) window.trackPicoUserAction('ai_calendar_connect_clicked', { provider: provider });

    btn.closest('#ai-connect-all-modal').modal('hide');

    if (!calendarId && !validateForm()) return;

    const popupWidth = 750;
    const popupHeight = 650;
    const popupLeft = (window.screen.width - popupWidth) / 2;
    const popupTop = (window.screen.height - popupHeight) / 4;
    const popup = window.open(
      'about:blank',
      'popup',
      `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop}`
    );

    btn.prop('disabled', true).text('Connecting...');

    ensureCalendar().done(function(id) {
      btn.prop('disabled', false).text('Connect');
      const ret = encodeURIComponent(calendarUrl(id));
      const oauthUrl = '/calendars/' + id + '/identities/connect/' + provider +
        '?inline=true&return_to=' + ret;
      if (popup && !popup.closed) {
        popup.location.href = oauthUrl;
      } else {
        openPopupWindow(oauthUrl);
      }
    }).fail(function() {
      btn.prop('disabled', false).text('Connect');
      if (popup && !popup.closed) {
        popup.close();
      }
      alert('Failed to create calendar. Please try again.');
    });
  });

  form.on('submit', function(e) {
    if (!validateForm()) {
      e.preventDefault();
      return false;
    }
  });

  if (calendarId) {
    setupBroadcastChannel(calendarId);
  }

  if ($websiteInput.prop('disabled')) {
    $websiteInput.on('show.bs.tooltip', function() {
      if (window.trackPicoUserAction) window.trackPicoUserAction('ai_calendar_disabled_website_tooltip_shown', {});
    });
  }

  $(document).on('click.aiCalendar', '#ai-see-more-trigger', function(e) {
    e.preventDefault();
    if (window.trackPicoUserAction) window.trackPicoUserAction('ai_calendar_see_more_clicked', {});
    $('#ai-connect-all-modal').modal('show');
  });

  $(document).on('click.aiCalendar', '#ai-advanced-settings-trigger', function(e) {
    e.preventDefault();
    if (window.trackPicoUserAction) window.trackPicoUserAction('ai_calendar_advanced_settings_clicked', {});
    $('#ai-advanced-settings-modal').modal('show');
  });

  $(document).on('change.aiCalendar', '#ai-advanced-settings-modal select, #ai-advanced-settings-modal .js-logo-image-input-field', function() {
    var field = $(this).attr('id') || $(this).attr('name') || 'logo';
    if (window.trackPicoUserAction) window.trackPicoUserAction('ai_calendar_advanced_setting_changed', { form_type: field });
  });

  $('#ai-connect-all-modal').on('click', '.btn-inline-social-connection, .load-modal', function() {
    $('#ai-connect-all-modal').modal('hide');
  });
});
